import React from 'react';

const Contact = () => {
  return (
    <main className="flex-grow container mx-auto px-4 py-8">
      {/* Hero section */}
      <div className="bg-gradient-to-r from-purple-600 to-indigo-800 rounded-xl shadow-lg mb-12 p-8 text-white">
        <h1 className="text-3xl md:text-4xl font-bold mb-4">
          Kapcsolat
        </h1>
        <p className="text-xl">
          Segítünk eligazodni a pályázati folyamatban
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {/* Kapcsolati információk */}
        <div className="bg-gradient-to-br from-purple-100 to-indigo-100 rounded-xl shadow-lg p-8 border border-purple-200">
          <h2 className="text-2xl font-bold mb-6 text-purple-900">Elérhetőségeink</h2>
          
          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <div className="text-purple-600">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-purple-900">E-mail</h3>
                <a href="mailto:nagyroland@webforyou.hu" className="text-purple-700 hover:text-purple-900 transition-colors">
                  nagyroland@webforyou.hu
                </a>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="text-purple-600">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-purple-900">Telefon</h3>
                <a href="tel:+36709083086" className="text-purple-700 hover:text-purple-900 transition-colors">
                  +36 70 908 3086
                </a>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="text-purple-600">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-purple-900">Cég</h3>
                <p className="text-purple-700">Webforyou Kft.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Gyors linkek */}
        <div className="bg-gradient-to-br from-purple-100 to-indigo-100 rounded-xl shadow-lg p-8 border border-purple-200">
          <h2 className="text-2xl font-bold mb-6 text-purple-900">Hasznos linkek</h2>
          
          <div className="space-y-4">
            <a 
              href="https://digitalisvallalkozas.neum.hu/register/vallalkozas"
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 bg-white/50 rounded-lg hover:bg-white/80 transition-colors"
            >
              <h3 className="text-lg font-semibold text-purple-900 mb-2">NEUM központi regisztráció</h3>
              <p className="text-purple-700">Regisztráljon a központi pályázati rendszerbe</p>
            </a>

            <a 
              href="https://forms.gle/mfDWN7v71sycLqbz8"
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 bg-white/50 rounded-lg hover:bg-white/80 transition-colors"
            >
              <h3 className="text-lg font-semibold text-purple-900 mb-2">Jelentkezési űrlap</h3>
              <p className="text-purple-700">Jelentkezzen szolgáltatásainkra</p>
            </a>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Contact; 